import { message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  ButtonItem,
  InputItem,
  ErrorItem,
} from "../../../../Components/Items";

class AgregarCanalVenta extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    visible: this.props.visible,
  };

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    if (values?.nombre && values?.codigo) {
      this.setState({ loading: true });
      axios
        .post(
          "canalesVenta/agregarCanalVenta",
          {
            ...values,
            empresaId: this.props.empresaId,
          },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          this.setState({ loading: false });
          if (res.data.success === 2) {
            message.success("Canal agregado exitosamente");
            this.cerrarModal(res.data.canalVentaId);
          } else if (res.data.success === 1) {
            message.error("No se pudo agregar el canal");
          } else {
            message.error("Sucedió un error y no se pudo agregar el canal");
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
          message.error("Error al comunicarse con el servidor");
        });
    } else {
      message.info("Proporcione al menos el código y el nombre del canal");
    }
  }

  cerrarModal(id) {
    this.setState({ visible: false });
    this.props.cerrarModal(id);
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
  }

  render() {
    return (
      <ModalItem
        title="Agregar Canal de Venta"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={() => this.cerrarModal()}
        width={800}
      >
        <Form
          ref={this.formRef}
          name="modalAgregarCanalVenta"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}
            >
              Guardar
            </ButtonItem>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          {/* Campo para el código del canal */}
          <FormItem
            name="codigo"
            label="Codigo"
            required
            margin
          >
            <InputItem placeholder="Ingresa el código" />
          </FormItem>

          {/* Campo para el nombre del canal */}
          <FormItem
            name="nombre"
            label="Nombre del Canal"
            required
            margin
          >
            <InputItem placeholder="Ingresa el nombre del canal" />
          </FormItem>

          {/* Campo para la descripción del canal */}
          <FormItem
            name="descripcion"
            label="Descripción del Canal"
            margin
          >
            <InputItem placeholder="Ingresa una breve descripción del canal" />
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(AgregarCanalVenta);
